import React from "react";
import './overall-class-performance-report.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants, Constants } from "../../../../constants/constants";
import Loading from "../../../common/loading/loading";
import SessionCache from "../../../routes/session-cache";
// import { CircularProgressbar } from "react-circular-progressbar";
import ReactTooltip from 'react-tooltip';
import CommonApi from "../../../../apis/common";
import { saveAs } from 'file-saver';
import HomeworkForClickerPracticeApi from "../../../../apis/homework-for-clicker-practice";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";


const greenColor = '#FFC257'

class OverallClassPerformanceReport extends React.Component {

    state = {
        overallMarksDetails: {
            markScored: 3,
            totalMark: 12,
            studentsAttempted: 1,
            subjectName: "Mathematics",
            chapterTitle: "Polynomials",
            class: "Class 10",
            novice: {
                level: "Novice (< 50%)",
                students: 1,
                scorePercentage: 25,
                markScored: 3,
                totalMark: 12,
            },
            proficient: {
                level: "Proficient (51% - 80%)",
                students: 0,
                scorePercentage: 0,
                markScored: 0,
                totalMark: 0,
            },
            advanced: {
                level: "Advanced (>80%)",
                students: 0,
                scorePercentage: 0,
                markScored: 0,
                totalMark: 0,
            },
            scorePercentage: 25,
            totalStudents: 50,
            sectionNameList: "A",
            overallCategoryList: [
                {
                    level: "Novice (< 50%)",
                    students: 1,
                    scorePercentage: 25,
                    markScored: 3,
                    totalMark: 12,
                },
                {
                    level: "Proficient (51% - 80%)",
                    students: 0,
                    scorePercentage: 0,
                    markScored: 0,
                    totalMark: 0,
                },
                {
                    level: "Advanced (>80%)",
                    students: 0,
                    scorePercentage: 0,
                    markScored: 0,
                    totalMark: 0,
                },
                {
                    level: "Total",
                    students: 1,
                    scorePercentage: 25,
                },
            ],
        },
        SectionwiseDetails: [
            {
                markScored: 3,
                totalMark: 12,
                section: "A",
                sectionId: "66f7f3f54fcf67ff711a1415",
                totalStudentsAttempted: 1,
                totalScorePercentage: 25,
                novice: {
                    level: "Novice (< 50%)",
                    students: 1,
                    scorePercentage: 25,
                    markScored: 3,
                    totalMark: 12,
                },
                proficient: {
                    level: "Proficient (51% - 80%)",
                    students: 0,
                    scorePercentage: 0,
                    markScored: 0,
                    totalMark: 0,
                },
                advanced: {
                    level: "Advanced (>80%)",
                    students: 0,
                    scorePercentage: 0,
                    markScored: 0,
                    totalMark: 0,
                },
                categoryList: [
                    {
                        level: "Novice (< 50%)",
                        students: 1,
                        scorePercentage: 25,
                        markScored: 3,
                        totalMark: 12,
                    },
                    {
                        level: "Proficient (51% - 80%)",
                        students: 0,
                        scorePercentage: 0,
                        markScored: 0,
                        totalMark: 0,
                    },
                    {
                        level: "Advanced (>80%)",
                        students: 0,
                        scorePercentage: 0,
                        markScored: 0,
                        totalMark: 0,
                    },
                    {
                        level: "Total",
                        students: 1,
                        scorePercentage: 25,
                    },
                ],
                totalStudents: 50,
            },
        ],
    }
    componentDidMount() {
        console.log(this.props.selectedItem)
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })

        this.getOverallClassPerformanceReport()
    }


    getOverallClassPerformanceReport() {

        let payload = {
            classText: "Class 10",
            board: "CBSE",
            type: "CLICKER_PRACTICE_STANDARD",
            chapterKey: "17440805076791547",
            chapterTitle: this.props.selectedItem.chapter
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getOverallClassPerformanceReport(payload).then(res => {
            console.log(res)
            this.setState({ ...res, isLoading: false })
        }).catch(err => {
            console.log(err)
        })
    }


    onClickBack() {
        this.props.close && this.props.close()
    }



    capitalizeWords(input) {
        return input
            .split(' ') // Split the string into an array of words
            .map(word =>
                word
                    .split('.') // Split the word by dots
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()) // Capitalize each part
                    .join('.') // Rejoin the parts with dots
            )
            .join(' '); // Join the words back into a single string
    }


    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    downloadPDF() {
        const link = document.createElement("a");
        link.href = this.state.link
        link.target = "_blank";
        link.download = "Class_Performance_Report.pdf"; // name for downloaded file
        link.click();
    }


    getSectionwiseTable(sectionDetails, index) {

        return (
            <div className={`${index != 0 ? 'mt-5' : ''}`}>
                <div className="d-flex">
                    <div className="class-text pr-3 border-right-gray">Section {sectionDetails.section}</div>
                    <div className="class-text pl-3 pr-3 border-right-gray">Students {sectionDetails.totalStudentsAttempted}/{sectionDetails.totalStudents}</div>
                    <div className="class-text pl-3">Question Accuracy {sectionDetails.accuracyPercentage}%</div>
                </div>
                <div className="d-flex mt-2">
                    <div className="over-all-text pr-5 pl-1 overall-border-left">Overall Class Score : {this.state.overallMarksDetails.scorePercentage}%</div>
                    <div className="over-all-text pl-1 section-score-border-left">Section {sectionDetails.section} Score : {sectionDetails.totalScorePercentage}%</div>
                </div>

                <div className={`row align-items-center ml-0 mr-0 p-1 mt-4`}>
                    <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                        <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${sectionDetails.totalScorePercentage !== 0 && sectionDetails.totalScorePercentage < 100 ? 'border-right-radius' : ''}`}
                            style={{ maxWidth: `${sectionDetails.totalScorePercentage}%`, background: `${sectionDetails.totalScorePercentage ? greenColor : 'none'}` }}>
                            {
                                this.state.overallMarksDetails.scorePercentage > 0 ? <div className="average-indicator" style={{ left: `${this.state.overallMarksDetails.scorePercentage}%` }}>
                                    <div className="average-number-absolute" style={{ left: `${this.state.overallMarksDetails.scorePercentage}%` }}>{this.state.overallMarksDetails.scorePercentage}%</div>
                                </div> : <></>
                            }
                        </div>
                    </div>
                    <div className="percentage-text ml-1">{sectionDetails.totalScorePercentage}%</div>
                </div>

                <div className="competency-table mt-4  card">
                    <table className="table table-bordered table-striped" style={{}}>
                        <thead className="class-header">
                            <tr className="first-header-bg">
                                <th className="" width='50%'>Level</th>
                                <th># Students</th>
                                <th>Score</th>

                            </tr>
                        </thead>
                        <tbody id="rows" className="class-body">
                            {
                                sectionDetails.categoryList &&
                                sectionDetails.categoryList.length &&
                                sectionDetails.categoryList.map((item, index) => (
                                    <>
                                        <tr>
                                            <td className={`${index === 0 ? 'novice-bullet-item' : ''} 
                                                                    ${index === 1 ? 'proficient-bullet-item' : ''} 
                                                                    ${index === 2 ? 'advanced-bullet-item' : ''}  
                                                                    ${index === 3 ? 'bold-text' : 'normal-text'} `}>
                                                {item.level}
                                            </td>
                                            <td className={` ${index === 3 ? 'bold-text' : 'normal-text'}  `}>
                                                {item.students}
                                            </td>
                                            <td className={` ${index === 3 ? 'bold-text' : 'normal-text'}  `}>
                                                {item.scorePercentage}%
                                            </td>
                                        </tr>
                                    </>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }


    render() {

        return (
            <div>
                <div className="overall-class-performance-report">
                    {
                        this.state.isLoading ? <Loading />
                            :
                            <>
                                <div>
                                    <img alt="" className='back-icon cursor-pointer mb-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                                </div>
                                <div className="school-name">Class Performance Report</div>
                                <div className="d-flex justify-content-between align-items-center  mb-3">
                                    <div className="header-subtext">{this.state?.userInfo?.schoolInfo?.name}</div>
                                    <div className="d-flex ">
                                        {/* <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadExcelReport()}>Export to Excel</div> */}
                                        <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Download PDF'}</div>
                                    </div>
                                </div>


                                <div className="mt-4">
                                    <div className="case-study-skill-border-container">
                                        <div className="bordered-text">Details</div>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <div className="d-flex">
                                                    <div className="class-text pr-3 border-right-gray">{this.state.overallMarksDetails.class}</div>
                                                    <div className="class-text pl-3 pr-3 border-right-gray">Section {this.state.overallMarksDetails.sectionNameList}</div>
                                                    <div className="class-text pl-3 pr-3 border-right-gray">Students {this.state.overallMarksDetails.studentsAttempted}/{this.state.overallMarksDetails.totalStudents}</div>
                                                    <div className="class-text pl-3">Question Accuracy {this.state.overallMarksDetails.accuracyPercentage}%</div>
                                                </div>

                                                <div className="d-flex mt-3">
                                                    <div className="class-text pr-3 border-right-gray">{this.state.overallMarksDetails.subjectName}</div>
                                                    <div className="class-text pl-3">Chapter(s)</div>
                                                </div>

                                                <div className="bullet-item d-flex align-items-center mt-2" >{this.state.overallMarksDetails.chapterTitle}</div>
                                            </div>
                                            <div className='mr-2 mb-2' style={{ width: '120px', height: '120px' }}>
                                                <div className="class-text">Overall Score</div>
                                                <CircularProgressbar

                                                    value={this.state.overallMarksDetails.scorePercentage && this.state.overallMarksDetails.scorePercentage > 0 ? this.state.overallMarksDetails.scorePercentage : 0}
                                                    strokeWidth={12}

                                                    styles={buildStyles({
                                                        textColor: "#333",
                                                        pathColor: "#118CEC",
                                                        trailColor: "#ddd",
                                                    })}
                                                    text={`${this.state.overallMarksDetails.scorePercentage}%`}
                                                />
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div className="mt-4 position-relative">
                                    <div className="overall-class-performance">
                                        <div className="bordered-text">Overall Class Performance</div>
                                        <div className="competency-table mt-2  card">
                                            <table className="table table-bordered table-striped" style={{}}>
                                                <thead className="class-header">
                                                    <tr className="first-header-bg">
                                                        <th className="" width='50%'>Level</th>
                                                        <th># Students</th>
                                                        <th>Score</th>

                                                    </tr>
                                                </thead>
                                                <tbody id="rows" className="class-body">
                                                    {
                                                        this.state.overallMarksDetails.overallCategoryList &&
                                                        this.state.overallMarksDetails.overallCategoryList.length &&
                                                        this.state.overallMarksDetails.overallCategoryList.map((item, index) => (
                                                            <>
                                                                <tr>
                                                                    <td className={`${index === 0 ? 'novice-bullet-item' : ''} 
                                                                    ${index === 1 ? 'proficient-bullet-item' : ''} 
                                                                    ${index === 2 ? 'advanced-bullet-item' : ''}  
                                                                    ${index === 3 ? 'bold-text' : 'normal-text'} `}>
                                                                        {item.level}
                                                                    </td>
                                                                    <td className={` ${index === 3 ? 'bold-text' : 'normal-text'}  `}>
                                                                        {item.students}
                                                                    </td>
                                                                    <td className={` ${index === 3 ? 'bold-text' : 'normal-text'}  `}>
                                                                        {item.scorePercentage}%
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>


                                <div className="mt-4 position-relative">
                                    <div className="section-wise-class-performance">
                                        <div className="bordered-text">Section - Wise Performance</div>
                                        {
                                            this.state.SectionwiseDetails.map((item, index) => (
                                                this.getSectionwiseTable(item, index)
                                            ))
                                        }

                                    </div>
                                </div>
                            </>
                    }
                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        )
    }
}

export default OverallClassPerformanceReport;